import * as actionTypes from '@/store/actions.type';
import * as mutationTypes from '@/store/mutations.type';
import api from '@/api';

const getDefaultNavbarSettings = () => {
  return {
    show: true,
    dense: false,
  };
};

const state = {
  navbar: getDefaultNavbarSettings(),
  settings: {},
  loading: false,
};

const getters = {
  navbarShow: (state) => state.navbar.show,
  toolbarDense: (state) => state.navbar.dense,
  settings: (state) => state.settings,
  loadingSettings: (state) => state.loading,
};

const actions = {
  [actionTypes.NAVBAR_STATE] ({ commit }, payload) {
    commit(mutationTypes.SET_NAVBAR_STATE, payload);
  },
  [actionTypes.NAVBAR_TOGGLE] ({ commit }, payload) {
    commit(mutationTypes.NAVBAR_TOGGLE, payload);
  },
  async [actionTypes.GET_CURRENT_SETTINGS] ({ commit }) {
    try {
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, true);

      const { data } = await api.settings.get();

      commit(mutationTypes.UPDATE_SETTINGS, data);
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, false);
    } catch (error) {
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, false);

      throw error;
    }
  },
  async [actionTypes.SAVE_SETTINGS] ({ commit }, payload) {
    try {
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, true);

      const { data } = await api.settings.update(payload);

      commit(mutationTypes.UPDATE_SETTINGS, data);
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, false);
    } catch (error) {
      commit(mutationTypes.UPDATE_LOADING_SETTINGS_STATE, false);

      throw error;
    }
  }
};

const mutations = {
  [mutationTypes.SET_NAVBAR_STATE] (state, payload) {
    state.navbar.show = payload.state;
  },
  [mutationTypes.NAVBAR_TOGGLE] (state) {
    state.navbar.show = !state.navbar.show;
  },
  [mutationTypes.UPDATE_SETTINGS] (state, payload) {
    state.settings = payload;
  },
  [mutationTypes.UPDATE_LOADING_SETTINGS_STATE] (state, payload) {
    state.loading = payload;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
}